import { getBucket } from '@mc/experiments'
import { isGDPRCountry } from '@mc/gdpr'
import { getGeo } from '@mc/geo'

import { userHasGivenGdprPermission } from './userHasGivenGdprPermission'

const SAVE_USER_DATA_FLAG_KEY = 'pen-3397_v1'

export const canSaveUserData = () =>
  passesGDPRCondition() && isSaveUserDataEnabled()

const passesGDPRCondition = () =>
  !isGDPRCountry(getGeo()) || userHasGivenGdprPermission()

const isSaveUserDataEnabled = () =>
  getBucket(SAVE_USER_DATA_FLAG_KEY)?.includes('variant')
